<template>
  <div class="submitCon">
    <!-- <div class="progress">
      <img src="../../img/m/progress.png" alt="" />
    </div> -->
    <div class="vlogCon">
      <div class="title">短视频 <span>VLOG</span></div>
      <div class="list">
        <videoupload></videoupload>
      </div>
    </div>
    <div class="vlogCon plogCon">
      <div class="title">图片故事 <span>PLOG</span></div>
      <div class="list">
        <plogoupload></plogoupload>
      </div>
    </div>
  </div>
</template>

<script>
import videoupload from './common/videoupload'
import plogoupload from './common/plogupload'
export default {
  name: "submitCon",
  components: {
    videoupload,
    plogoupload
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.submitCon {
  width: 1200px;
  margin: 50px auto;
  text-align: center;
  font-size: 20px;
  text-align: left;
  .progress {
    width: 1200px;
    img {
      width: 100%;
    }
  }
  .vlogCon {
    width: 1200px;
    padding: 0 40px 40px;
    margin-top: 100px;
    box-sizing: border-box;
    background-color: rgba(#fff, 0.8);
    .title {
      width: 405px;
      height: 70px;
      line-height: 70px;
      text-align: center;
      background-image: linear-gradient(0deg, #746bef 0%, #728bf9 100%);
      border-radius: 35px;
      margin: auto;
      font-size: 50px;
      color: #fff;
      font-weight: bold;
      position: relative;
      top: -35px;
      span {
        font-size: 26px;
        opacity: 0.6;
      }
    }
    .list {
      
    }
  }
  .plogCon {
    margin-top: 60px;
    position: relative;
    &:before {
      content: '';
      position: absolute;
      left: 58px;
      top: -88px;
      background-image: url(../../img/link.png);
      background-repeat: no-repeat;
      background-size: 100%;
      width: 22px;
      height: 110px;
    }
    &:after {
      content: '';
      position: absolute;
      right: 58px;
      top: -88px;
      background-image: url(../../img/link.png);
      background-repeat: no-repeat;
      background-size: 100%;
      width: 22px;
      height: 110px;
    }
  }
}
</style>
